<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <el-row :gutter="20" >
        <el-col :span="6"  class="item">
          <el-card :body-style="{ padding: '0px' }">               
            <div style="padding: 14px;">
              <div class="price">{{headStatic.order}}元</div>
              <div class="title">今日订单</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6"  class="item">
            <el-card :body-style="{ padding: '0px' }">               
            <div style="padding: 14px;">
              <div class="price">{{headStatic.consume}}元</div>
              <div class="title">今日消费</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6"  class="item">
          <el-card :body-style="{ padding: '0px' }">               
            <div style="padding: 14px;">
              <div class="price">{{headStatic.taobao}}元</div>
              <div class="title">淘宝订单</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6"  class="item">
          <el-card :body-style="{ padding: '0px' }">               
            <div style="padding: 14px;">
              <div class="price">{{headStatic.pdd}}元</div>
              <div class="title">拼多多订单</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12"  class="item">
          <el-card :body-style="{ padding: '0px' }" title="哈哈">
            <div slot="header" class="clearfix">
              <span>近7天订单金额走势</span>
            </div>
            <e-charts class="chart" :option="orderOption" />
          </el-card>
        </el-col>
        <el-col :span="12"  class="item">
          <el-card :body-style="{ padding: '0px' }" title="哈哈">
            <div slot="header" class="clearfix">
              <span>近7天消费金额走势</span>
            </div>
            <e-charts class="chart" :option="consumeOption" />
          </el-card>
        </el-col>
      </el-row>        
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {      
        loading:true,
        headStatic:{},
        consumeDays:[],
        orderDays:[]
      }
    },
    computed:{
      orderOption () {
        return {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['订单金额']
          },
          xAxis: {
            type: 'category',
            data: this.orderDays.map(item => item.date)
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '订单金额',
              data: this.orderDays.map(item => item.value),
              type: 'bar'
            }
          ]
        }
      },
      consumeOption () {
        return {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['消费金额']
          },
          xAxis: {
            type: 'category',
            data: this.consumeDays.map(item => item.date)
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '消费金额',
              data: this.consumeDays.map(item => item.value),
              type: 'bar'
            }
          ]
        }
      }
    },
    mounted(){
      this.GetDate();
    },
    components:{ 
    },
    methods:{  
      GetDate:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Dashboard/Index',          
        }).then(function (resp) {
          that.headStatic = resp.data.headStatic
          that.consumeDays = resp.data.consumeDays
          that.orderDays = resp.data.orderDays
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      }
    },
    created(){    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-main
  padding 24px
.item
  padding-top 20px
.title
  font-size 16px
  font-weight: 500
  color rgba(0, 0, 0, 0.85)
  text-align: right 
.desction
  height 50px
  margin-top 5px
  color rgba(0, 0, 0, 0.45)
.price
  height 60px
  line-height 60px
  font-size 24px
  text-align right 
  color #578ebe
  font-weight: 700
.chart
  height 400px
</style>